import React, { PropTypes } from 'react'
import classnames from 'classnames'
import Banner from 'components/Banner'
import { Column, Container, Row } from 'components/Grid'
import Sidebar from 'components/Sidebar'
import styles from './MainLayout.scss'

const MainLayout = ({
  bannerNavProps,
  children,
  className,
  showSidebar,
  sidebarType,
  partnerSideBarInfo,
  partnerPlanDocuments,
  partnerPlanSideNav,
  currentUser,
  handleOpenDialog,
  modalHide,
  modalShow,
}) => {
  return (
    <main className={classnames(styles.base, className)}>
      <Banner {...bannerNavProps} />
      <Container>
        <Row>
          <Column base={showSidebar ? 13 : 18}>
            {children}
          </Column>
          {showSidebar &&
            <Column base={5}>
              <Sidebar
                currentUser={currentUser} // JSON.parse(sessionStorage.getItem('CurrentUser'))
                handleOpenDialog={handleOpenDialog}
                modalHide={modalHide}
                modalShow={modalShow}
                partnerPlanDocuments={partnerPlanDocuments}            
                partnerPlanSideNav={partnerPlanSideNav}
                partnerSideBarInfo={partnerSideBarInfo}
                type={sidebarType}
              />
            </Column>
          }
        </Row>
      </Container>
    </main>
  )
}

MainLayout.propTypes = {
  bannerNavProps: PropTypes.shape({
    accountStats: PropTypes.bool,
    bannerSelectProps: PropTypes.shape({
      className: PropTypes.string,
      context: PropTypes.object,
      currentSelection: PropTypes.string.isRequired,
      onChange: PropTypes.func,
      options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })).isRequired,
      suffix: PropTypes.string,
    }),
    defaultBack: PropTypes.string,
    // entityCount: PropTypes.number,
    // groupCount: PropTypes.number,
    // links: PropTypes.arrayOf(PropTypes.shape({
    //   action: PropTypes.func,
    //   isActive: PropTypes.bool,
    //   label: PropTypes.string.isRequired,
    //   to: PropTypes.string,
    // })),
    subTitle: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  currentUser: PropTypes.object,
  handleOpenDialog: PropTypes.func,
  partnerPlanDocuments: PropTypes.object,
  partnerPlanSideNav: PropTypes.object,
  partnerSideBarInfo: PropTypes.string,
  showSidebar: PropTypes.bool,
  sidebarType: PropTypes.string,
}

MainLayout.defaultProps = {
  bannerNavProps: null,
  children: null,
  className: null,
  currentUser: null,
  handleOpenDialog: null,
  showSidebar: true,
  sidebarType: 'partnerSideBar',
  partnerSideBarInfo: '',
  partnerPlanDocuments: null,
  partnerPlanSideNav: null,
}

export default MainLayout



// WEBPACK FOOTER //
// ./src/components/MainLayout/MainLayout.js